import { useSearchParams } from 'next/navigation'

export const useIntendedPath = () => {
  const searchParams = useSearchParams()

  const raw = searchParams?.get('intended') || searchParams?.get('path') || ''
  if (!raw) return undefined

  // Open redirect defense: only allow same-origin relative paths.
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) {
    return undefined
  }

  return raw
}
